import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'

export const DELETE_INITIATIVE_CONFIRM_IDENTIFIER: ConfirmDialogIdentifier =
  'DeleteInitiativeConfirm'
